import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shop-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 21V10C4 8 6 3 12 3C18 3 20 8 20 10V21H4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15 21H9V16.9997C9 15.3429 10.3431 14 12 14C13.6569 14 15 15.3431 15 17V21Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 21H9V16.9997C9 15.3429 10.3431 14 12 14C13.6569 14 15 15.3431 15 17V21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 10V21H20V10M4 10H20M4 10C4 8 6 3 12 3C18 3 20 8 20 10M3 10H21M3 21H21M11.417 3.5C10.2265 4.77897 9 7.59799 9 10M12.583 3.5C13.7735 4.77897 15 7.59799 15 10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Shop2 = Vue.extend<IconProps>({
  name: 'Shop2Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'shop-2',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Shop2;
